import NotFound from "./notFound";
function NotFound_EN(){
    return (
        <>
        <NotFound />
        </>
    )
}


export default NotFound_EN